import { StudentGroup } from './types';

export const mockStudentGroups: StudentGroup[] = [
  {
    id: 'group-001',
    name: 'Advanced Math',
    description: 'Students who excel in mathematics and demonstrate exceptional problem-solving abilities. This group focuses on advanced concepts and challenging problems to further develop their mathematical thinking and prepare them for competitions.',
    teacherId: 'teacher-001',
    students: ['student-001', 'student-003', 'student-007'],
    status: 'active',
    learningPaths: ['path-001', 'path-003', 'path-004', 'path-005'],
    createdAt: '2023-04-15T09:30:00Z',
    updatedAt: '2023-04-15T09:30:00Z',
  },
  {
    id: 'group-002',
    name: 'Fractions Focus',
    description: 'Students who need additional help with fractions',
    teacherId: 'teacher-001',
    students: ['student-002', 'student-004', 'student-008'],
    status: 'active',
    learningPaths: ['path-002'],
    createdAt: '2023-04-16T10:15:00Z',
    updatedAt: '2023-05-01T14:20:00Z',
  },
  {
    id: 'group-003',
    name: 'Geometry Stars',
    description: 'Students with strong spatial reasoning skills',
    teacherId: 'teacher-001',
    students: ['student-005', 'student-009', 'student-011'],
    status: 'inactive',
    learningPaths: [],
    createdAt: '2023-04-18T11:45:00Z',
    updatedAt: '2023-04-18T11:45:00Z',
  },
  {
    id: 'group-004',
    name: 'Problem Solvers',
    description: 'Students who excel at word problems and logical reasoning',
    teacherId: 'teacher-001',
    students: ['student-006', 'student-010', 'student-012'],
    status: 'active',
    learningPaths: ['path-001'],
    createdAt: '2023-04-20T13:30:00Z',
    updatedAt: '2023-05-05T09:15:00Z',
  },
];
